import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ImageBackground, Text, View, Image, Animated, Platform, Linking } from 'react-native';

import { ListItem } from '../atoms/listitem';
import RentalPortal from '../../rentalPortal';
import { COLORS } from '../../../constants/colorPallete';
import { getProfile } from '../../../redux/actions/auth';
import getPlatformType, { getImage } from '../../../helpers/getPlatform';
import BackButton from '../../../commonComponents/BackButton';
import CircularProgress from '../../../commonComponents/circle';
import { tenantActions } from './../openFlowRedux/tenant.actions';
import { navigateAction } from '../../../helpers/navigationHelpers';
import { CircularWrapper } from '../../identifyAndFinance/stylesNew';
import { MainContainer, PropertyDetailsSection, Wrapper } from './home.styles';
import BackGroundGenerator from '../../LandingPages/common/BackGroundGenerator';
import HomeBoxCard from '../../identifyAndFinance/HomeBox';
import { StyleSheet } from 'react-native';
import { Typography } from '../../tds/style';
import IdRef from '../../../assets/images/idRef.png';
import WideButton from '../../../commonComponents/wideButton';
import { callIfAvailable, sendEmail } from '../../../helpers/callEmailHelper';
import ODSButton from '../../../../openbrix-design-system/ui/atoms/ODSButton';
import { ChildrenView } from '../../idVerification/styles';
import { Dimensions } from 'react-native';
import PropertyBox from '../../../../openbrix-design-system/ui/molecules/propertyBox';
import RentSetting from '../../../../openbrix-design-system/ui/molecules/rentSetting';
import OpenflowCard from '../../../../openbrix-design-system/ui/molecules/propertyBox/openflowCard';
import { ODSText } from '../../../../openbrix-design-system/ui/atoms/ODSText';
import { getTokens } from '../../../../openbrix-design-system/design-tokens/color-tokens';
import { CardBox } from '../atoms/card';
import moment from 'moment';
import Report from '../../../../openbrix-design-system/ui/molecules/Report';
import RentReviewCard from '../../../../openbrix-design-system/ui/molecules/RentReviewCard';
import { getServerURL } from '../../../helpers/functionHelpers';

const layoutType = getPlatformType();
const WIN_HEIGHT = Dimensions.get('window').height;

const SkeletonBlock = ({ width, height, borderRadius = 8, style }) => {
  const shimmerAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const loop = Animated.loop(
      Animated.timing(shimmerAnim, {
        toValue: 1,
        duration: 1200,
        useNativeDriver: true,
      })
    );
    loop.start();
    return () => loop.stop();
  }, [shimmerAnim]);

  const translateX = shimmerAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [-200, 200],
  });

  return (
    <View
      style={[
        {
          width,
          height,
          backgroundColor: '#EAECF0',
          overflow: 'hidden',
          borderRadius,
        },
        style,
      ]}
    >
      <Animated.View
        style={[
          {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            transform: [{ translateX }],
            backgroundColor: '#F2F4F7',
            opacity: 0.6,
          },
        ]}
      />
    </View>
  );
};

const MyTenancySkeleton = () => {
  const cardCount = layoutType === 'web' ? 6 : 4;
  const isPhone = layoutType === 'phone';
  return (
    <View style={isPhone ? { paddingHorizontal: 16 } : undefined}>
      <View
        style={
          layoutType !== 'web'
            ? { flexDirection: 'column', top: isPhone ? -80 : -120 }
            : { alignSelf: 'center', flexDirection: 'row' }
        }
      >
        <View style={layoutType !== 'web' ? { width: '100%' } : { width: 407 }}>
          <View
            style={{
              backgroundColor: '#FFF',
              borderRadius: 12,
              padding: 16,
              borderWidth: 1,
              borderColor: '#E2E8F0',
            }}
          >
            <SkeletonBlock width="100%" height={isPhone ? 140 : 160} borderRadius={10} style={{ marginBottom: 14 }} />
            <SkeletonBlock width="70%" height={20} style={{ marginBottom: 8 }} />
            <SkeletonBlock width="90%" height={14} style={{ marginBottom: 16 }} />
            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
              <SkeletonBlock width="48%" height={40} borderRadius={20} />
              <SkeletonBlock width="48%" height={40} borderRadius={20} />
            </View>
          </View>
          {layoutType !== 'web' && (
            <View style={{ marginTop: 16 }}>
              <SkeletonBlock width="100%" height={72} borderRadius={12} style={{ marginBottom: 12 }} />
              <SkeletonBlock width="100%" height={72} borderRadius={12} />
            </View>
          )}
        </View>
        {layoutType === 'web' && (
          <View style={{ width: 407, marginLeft: 10 }}>
            <SkeletonBlock width="100%" height={88} borderRadius={12} style={{ marginBottom: 16 }} />
            <SkeletonBlock width="100%" height={88} borderRadius={12} />
          </View>
        )}
      </View>

      <View style={{ alignSelf: 'center', marginTop: layoutType !== 'web' ? -40 : 30, marginBottom: 30 }}>
        <SkeletonBlock width={220} height={28} borderRadius={6} />
      </View>

      <View
        style={
          layoutType === 'web'
            ? { alignSelf: 'center', flexDirection: 'row', flexWrap: 'wrap', width: 1050 }
            : { alignSelf: 'center', flexDirection: 'column', width: '100%', top: isPhone ? -60 : -120 }
        }
      >
        {Array.from({ length: cardCount }).map((_, index) => (
          <View
            key={`skel-card-${index}`}
            style={
              layoutType !== 'web'
                ? { width: '100%', marginBottom: 16 }
                : { width: 500, margin: 10 }
            }
          >
            <View
              style={{
                backgroundColor: '#FFF',
                borderRadius: 12,
                padding: 16,
                borderWidth: 1,
                borderColor: '#E2E8F0',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <SkeletonBlock width={48} height={48} borderRadius={24} style={{ marginRight: 14 }} />
              <View style={{ flex: 1 }}>
                <SkeletonBlock width="60%" height={16} style={{ marginBottom: 8 }} />
                <SkeletonBlock width="90%" height={12} />
              </View>
              <SkeletonBlock width={72} height={28} borderRadius={14} style={{ marginLeft: 12 }} />
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

const ListArray = [
  {
    title: 'Tenant Details',
    buttonStatus: 'tenancy_status',
    routeKey: 'TenantDetails',
    desc: 'Are your details correct and complete?',
    id: 'tenantDetails',
    listIcon: "TB-User-Circle",
  },
  {
    title: 'Landlord & Property Document',
    buttonStatus: 'doc_status',
    routeKey: 'PropertyDocs',
    desc: 'Documentation to read and retain',
    id: 'landlord-PropertyDocument',
    listIcon: "doc",
  },
  {
    title: 'Rental Offer',
    buttonStatus: 'rental_offer_status',
    routeKey: 'RentalOffers',
    desc: 'Breakdown of your rental offer',
    id: 'rentalOffer',
    listIcon: "rentaloffer",
  },
  {
    title: 'Holding Deposit',
    buttonStatus: 'holding_deposit_status',
    routeKey: 'HoldingDeposit',
    desc: 'Holding deposit details and terms may be view here',
    id: 'holdingDeposit',
    listIcon: "pound",
  },
  {
    title: 'ID & Referencing',
    buttonStatus: 'verification_status',
    routeKey: 'IdAndReference',
    desc: 'Verify ID and begin the reference process.',
    id: 'id-Referncing',
    listIcon: "idref",
  },
  {
    title: 'Tenancy Agreement',
    buttonStatus: 'landlord_status',
    routeKey: 'ReviewAPT',
    desc: 'Digitally sign your tenancy agreement and send it back to your agent.',
    id: 'tenancyAgreement',
    listIcon: "agrement",
  },
  {
    title: 'Move in',
    buttonStatus: 'move_in_status',
    routeKey: 'DepositInfo',
    desc: "Breakdown of your 'move in monies'",
    id: 'moveIn',
    listIcon: "movein",
  },
  {
    title: 'Deposit Protect & Home Setup',
    buttonStatus: 'property_status',
    routeKey: 'DepositProtection',
    desc: 'Set up your new home.',
    id: 'depositProtect-HomeSetUp',
    listIcon: "depositprotect",
  },
  {
    title: 'Maintenance Issue',
    buttonStatus: 'maintenance_status',
    routeKey: 'ViewMaintenance',
    desc: 'Do you have a maintenance issue? Report or view your requests here.',
    id: 'maintenanceIssue',
    listIcon: "TB-Notifications-Settings",
  },
  {
    title: 'Rent Review Request',
    buttonStatus: 'rent_review_status',
    routeKey: 'RentReview',
    desc: 'You have a pending rent review request.',
    id: 'rentReviewRequest',
    listIcon: "TB-Alert",
  },
];
const ListArrayRenew = [
  {
    title: 'Tenant',
    buttonStatus: 'tenancy_status',
    routeKey: 'TenantDetails',
    desc: 'Please check your details are correct.',
    id: 'tenantDetails',
    listIcon: "TB-User-Circle",
  },
  {
    title: 'Landlord & Property Document',
    buttonStatus: 'doc_status',
    routeKey: 'PropertyDocs',
    desc: 'Documentation to read and retain',
    id: 'landlord-PropertyDocument',
    listIcon: "doc",
  },
  {
    title: 'Renewal Offer',
    buttonStatus: 'rental_offer_status',
    routeKey: 'RentalOffers',
    desc: 'Breakdown of your rental offer',
    id: 'rentalOffer',
    listIcon: "rentaloffer",
  },
  {
    title: 'Holding Deposit',
    buttonStatus: 'holding_deposit_status',
    routeKey: 'HoldingDeposit',
    desc: 'Holding deposit details and terms may be view here',
    id: 'holdingDeposit',
    listIcon: "pound",
  },
  {
    title: 'ID & Full Reference',
    buttonStatus: 'verification_status',
    routeKey: 'IdAndReference',
    desc: 'Verify ID and begin the reference process.',
    id: 'id-Referncing',
    listIcon: "idref",
  },
  {
    title: 'Tenancy Agreement',
    buttonStatus: 'landlord_status',
    routeKey: 'ReviewAPT',
    desc: 'Digitally sign your renewal agreement',
    id: 'tenancyAgreement',
    listIcon: "agrement",
  },
  {
    title: 'Renewal Payments',
    buttonStatus: 'move_in_status',
    routeKey: 'DepositInfo',
    desc: "Breakdown of your new payments.",
    id: 'moveIn',
    listIcon: "movein",
  },
  {
    title: 'Deposit Protect & Home Setup',
    buttonStatus: 'property_status',
    routeKey: 'DepositProtection',
    desc: 'Check you have the best utility deals currently available.',
    id: 'depositProtect-HomeSetUp',
    listIcon: "depositprotect",
  },
  {
    title: 'Maintenance Issue',
    buttonStatus: 'maintenance_status',
    routeKey: 'ViewMaintenance',
    desc: 'Do you have a maintenance issue? Report or view your requests here.',
    id: 'maintenanceIssue',
    listIcon: "TB-Notifications-Settings",
  },
  {
    title: 'Rent Review Request',
    buttonStatus: 'rent_review_status',
    routeKey: 'RentReview',
    desc: 'You have a pending rent review request.',
    id: 'rentReviewRequest',
    listIcon: "TB-Alert",
  },
];
const ListArrayMoveOut = [
  {
    title: 'Tenant',
    buttonStatus: 'tenancy_status',
    routeKey: 'TenantDetails',
    desc: 'Please check your details are correct.',
    id: 'tenantDetails',
    listIcon: "TB-User-Circle",
  },
  {
    title: 'Notice',
    buttonStatus: 'doc_status',
    routeKey: 'Notice',
    desc: 'Your notice, together with any supporting documents will be stored here.',
    id: 'landlord-PropertyDocument',
    listIcon: "msg",
  },
  {
    title: 'Check Out',
    buttonStatus: 'check_out_status',
    routeKey: 'CheckOut',
    desc: 'Details of your check out may be found here together with an End of Tenancy Guide',
    id: 'rentalOffer',
    listIcon: "rentaloffer",
  },
  {
    title: 'Deposit Protection',
    buttonStatus: 'property_status',
    routeKey: 'DepositProtection',
    desc: 'Deposit return information and utility setup.',
    id: 'depositProtect-HomeSetUp',
    listIcon: "depositprotect",
  },
  {
    title: 'Forwarding Address',
    buttonStatus: 'verification_status',
    routeKey: 'ForwardMessege',
    desc: 'Add or confirm address details for your new home.',
    id: 'rentalOffer',
    listIcon: "location",
  },
];

import { getRentReviewOverallStatus, shouldShowRentReviewEntryPoints } from '../../../../openbrix-design-system/utils/rentReviewUtils';

const Home = (props) => {
  const { navigation } = props;
  const dispatch = useDispatch();
  const [flowId, setFlowId] = React.useState(null);
  const [type, setType] = React.useState("Move In");
  const [listItemState, setListItemState] = React.useState(ListArray);

  const [flowIdInfo, setFlowIdInfo] = React.useState(null);
  const globalState = useSelector((state) => state?.tenant);
  const profile = useSelector((state) => state.authReducer.profile);
  const authDataFromMobile = useSelector((state) => state?.appReducer?.mobileData?.data?.isWebView);
  const routeFlowId = props?.route?.params?.id;
  const isFlowReady =
    Boolean(flowIdInfo) &&
    String(flowIdInfo?.openflow_id) === String(routeFlowId);
  const showSkeleton = Boolean(globalState?.flowInfoLoading) || !isFlowReady;

  useEffect(() => {
    if (props?.route?.params?.id) {
      dispatch(tenantActions.getFlowInfo(props?.route?.params?.id));
      dispatch(tenantActions.getRentReview(props?.route?.params?.id));
    }
  }, [props?.route?.params?.id]);

  useEffect(() => {
    const rawParam = props?.route?.params?.isMoveOut;
    const isMoveOutExplicit =
      rawParam === true ||
      String(rawParam).toLowerCase() === 'true';

    if (isMoveOutExplicit || globalState?.flowIdInfo?.is_move_out) {
      dispatch(tenantActions.getMoveOutData(props?.route?.params?.id));
    }
  }, [globalState?.flowIdInfo?.is_move_out, props?.route?.params?.isMoveOut, props?.route?.params?.id]);

  React.useEffect(() => {
    if (globalState) {
      const flowInfo = globalState?.flowIdInfo;
      const showRentReviewEntryPoints = shouldShowRentReviewEntryPoints(flowInfo);

      // Safe parsing for both Web (string "true") and Mobile (boolean true)
      const rawParam = props?.route?.params?.isMoveOut;
      const isMoveOutExplicit =
        rawParam === true ||
        String(rawParam).toLowerCase() === 'true';

      // If explicitly requested as Move Out -> Move Out
      // Else if renewed -> Renewal
      // Else -> Move In
      let listToSet = ListArray;
      if (isMoveOutExplicit) {
        setType("Move Out");
        listToSet = ListArrayMoveOut;
      } else if (flowInfo?.is_renewed) {
        setType("Renewal");
        listToSet = ListArrayRenew;
      } else {
        setType("Move In");
        listToSet = ListArray;
      }

      if (!showRentReviewEntryPoints) {
        listToSet = listToSet.filter((item) => item.routeKey !== 'RentReview' && item.id !== 'rentReviewRequest');
      }

      setListItemState(listToSet);
    }
    setFlowId(props?.route?.params?.id);
    setFlowIdInfo(globalState?.flowIdInfo);
  }, [globalState, props?.route?.params?.id, props?.route?.params?.isMoveOut, props?.route?.params?.data]);

  const getMoveOutItemStatus = (routeKey) => {
    const resolvedData = globalState?.moveOutData?.data || globalState?.moveOutData;
    if (routeKey === 'TenantDetails') {
      return flowIdInfo?.tenancy_status || 0;
    }
    if (routeKey === 'Notice') {
      const noticeObj = resolvedData?.open_flow_move_out_notice;
      const isCompleted = noticeObj?.notice_received_completed && noticeObj?.notice_served_completed;
      return noticeObj ? (isCompleted ? 1 : 4) : 0;
    }
    if (routeKey === 'CheckOut') {
      const checkoutObj = resolvedData?.open_flow_move_out_checkout;
      const hasMeterReadings = Array.isArray(resolvedData?.open_flow_move_out_meter_readings) && resolvedData.open_flow_move_out_meter_readings.length > 0;
      const hasInventoryDocs = Array.isArray(resolvedData?.open_flow_move_out_inventory_documents) && resolvedData.open_flow_move_out_inventory_documents.length > 0;
      const isCheckoutCompleted = checkoutObj ? (checkoutObj.is_completed || (hasMeterReadings && hasInventoryDocs)) : false;
      return checkoutObj ? (isCheckoutCompleted ? 1 : 4) : 0;
    }
    if (routeKey === 'DepositProtection') {
      const depositObj = resolvedData?.open_flow_move_out_deposit;
      return depositObj ? (depositObj.is_completed ? 1 : 4) : 0;
    }
    if (routeKey === 'ForwardMessege') {
      const forwardingAddresses = resolvedData?.open_flow_move_out_forwarding_addresses;
      if (Array.isArray(forwardingAddresses)) {
        const isCompleted = forwardingAddresses.some((address) => address?.tenant_confirm || address?.teanant_confirm);
        if (isCompleted) return 1;
        return forwardingAddresses.length > 0 ? 4 : 0;
      }
      const finalAddress = resolvedData?.open_flow_move_out_forwarding_address || resolvedData?.forwarding_address;
      const isCompleted = finalAddress?.tenant_confirm || finalAddress?.teanant_confirm;
      return finalAddress ? (isCompleted ? 1 : 4) : 0;
    }
    return 0;
  };


  const emailAgent = async () => {
    let mailId = flowIdInfo?.branch?.email ? flowIdInfo?.branch?.email : 'Info@openbrix.co.uk';
    let mailTitle = 'Message from tlyfe openflo tenant';
    let mailBody = `Dear ${flowIdInfo?.branch?.name},
        
        I am currently using your tenant move in process and would like to discuss the following points.
    
    
        [Add your points here]
        
        
        Kind regards,
        ${profile?.data?.first_name + ' ' + profile?.data?.last_name}`;
    let url = `mailto:${mailId}?subject=${encodeURIComponent(mailTitle)}&body=${encodeURIComponent(
      mailBody
    )}`;
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      window.open(url, '_blank');
    } else {
      Linking.openURL(url);
    }
  };
  const callAgent = async (x) => {
    let status = false;
    if (x) {
      callIfAvailable(x);
      // status = await callIfAvailable(x);
      // if (!status) {
      //   dispatch(showToaster("error", "Sorry, agent's contact unavailable"));
      // }
    } else if (!status) {
      dispatch(showToaster('error', "Sorry, agent's contact unavailable"));
    }
  };
  const renderCallButton = () => {
    return (
      <View style={{ flexDirection: layoutType != 'phone' ? 'row' : 'column', marginTop: 20 }}>
        <View
          style={
            layoutType != 'phone'
              ? {
                flex: 1,
                paddingRight: 6,
              }
              : { flex: 0.5, marginBottom: 10 }
          }
        >
          <WideButton
            childText={'Call Agent'}
            buttonType={'solid'}
            gradiant
            isLGreen

          />
        </View>
        <View
          style={
            layoutType != 'phone'
              ? {
                flex: 1,
                paddingLeft: 6,
              }
              : { flex: 0.5 }
          }
        >
          <WideButton
            childText={'Email Agent'}
            buttonType={'solid'}
            gradiant
            onPress={() => { }}
            isLGreen
          />
        </View>
      </View>
    );
  };
  const renderPropertyBox = () => (
    <View style={styles.imageBackgroundContentContainer}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#FFF',
          borderRadius: 8,
          shadowColor: '#000',
          shadowOffset: { width: 1, height: 3 },
          shadowOpacity: 0.15,
          shadowRadius: 8,
          elevation: 5,
        }}
      >
        <Image
          source={{
            uri: flowIdInfo?.property?.property_images?.length
              ? flowIdInfo?.property?.property_images[0]
              : 'http://assets.openbrix.co.uk/certificate-doc-oWHno-1663268711051-0.png',
          }}
          resizeMode="cover"
          style={styles.floBackg}
        />

        <View style={{ padding: 10, marginTop: 10, flex: 6 }}>
          <Typography align={'left'} size={'24px'} color={COLORS.LGREEN}>
            {flowIdInfo?.property?.property_name ? flowIdInfo?.property?.property_name : ''}
          </Typography>
          <Typography align={'left'} size={'18px'} color={COLORS.BLACK}>
            {flowIdInfo?.property?.display_address ? flowIdInfo?.property?.display_address : ''}
          </Typography>
        </View>
        <View style={{ flex: 2 }}>
          <CircularWrapper>
            <CircularProgress
              size={65}
              strokeWidth={2}
              progressPercent={
                flowIdInfo?.percentage_completed ? flowIdInfo?.percentage_completed : 0
              }
              pgColor={COLORS.GREEN}
              pointerColor={COLORS.GREEN}
              customText={
                flowIdInfo?.percentage_completed ? flowIdInfo?.percentage_completed + '%' : 0
              }
              textColor={'white'}
              textSize={'14'}
            ></CircularProgress>
          </CircularWrapper>
        </View>
      </View>
      {renderCallButton()}
    </View>
  );
  console.log('flowIdInfo', flowIdInfo);
  const themeObj = getTokens('light').colors;
  return (
    <BackGroundGenerator
      openFlowData={{
        title: '',
        desc: '',
        buttonText: '',
        message: '',
      }}
      isOpenflowContainer
      props={props}
      isTLYF
      navigation={navigation}
      isOpenflowHome={'My Tenancy Home'}
    >
      {showSkeleton ? (
        <MyTenancySkeleton />
      ) : (
        <>
      <View style={layoutType !== "web" ? { flexDirection: "column", top: layoutType != 'web' && -120 } : { alignSelf: "center", flexDirection: "row" }}>
        <View style={layoutType !== "web" ? {} : { width: 407 }}>
          <PropertyBox
            knobCount={flowIdInfo?.percentage_completed}
            type={type}
            onCallPress={() =>
              callAgent(
                profile?.data?.agentDetails?.branch?.contact_number
                  ? profile.data.agentDetails.branch.contact_number
                  : '0203 740 4721'
              )
            }
            agentName={[flowIdInfo?.branch?.company?.name, flowIdInfo?.branch?.name]
              .filter(Boolean) // Removes undefined, null, and empty strings
              .join(", ")}
            onEmailPress={() => { emailAgent() }}
            uri={flowIdInfo?.property?.property_images?.length
              ? flowIdInfo?.property?.property_images[0]
              : 'http://assets.openbrix.co.uk/certificate-doc-oWHno-1663268711051-0.png'}
            name={flowIdInfo?.property?.property_name ? flowIdInfo?.property?.property_name : ''}
            address={flowIdInfo?.property?.display_address ? flowIdInfo?.property?.display_address : ""}
          />
          {flowIdInfo?.percentage_completed == 100 && (
            <View style={[styles.containerStyle, { marginTop: 16 }]} hasBorderRadius>
              <ODSText textAlign={'left'} marginTop={4} color={themeObj.text.secondary} type={'md-bold'}>Tenancy Details</ODSText>
              <View style={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between', marginBottom: 8, marginTop: 12 }}>
                <View style={{ flex: 0.5 }}>
                  <ODSText type='sm-bold' color={themeObj.text.primary}>Deposit Amount</ODSText>
                  <ODSText type='sm' color={themeObj.text.primary}>£{flowIdInfo?.open_flow_rental_offer?.tenancy_deposit_amount}</ODSText>
                </View>
                <View style={{ flex: 0.5 }}>
                  <ODSText type='sm-bold' color={themeObj.text.primary}>Rental Period</ODSText>
                  <ODSText type='sm' color={themeObj.text.primary}>{moment(flowIdInfo?.open_flow_rental_offer?.tenancy_start_date).format('Do MMM YYYY')} to {moment(flowIdInfo?.open_flow_rental_offer?.tenancy_end_date).format('Do MMM YYYY')}</ODSText>
                </View>
              </View>
              <View style={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between', marginBottom: 8 }}>
                <View style={{ flex: 0.5 }}>
                  <ODSText type='sm-bold' color={themeObj.text.primary}>No.of residents</ODSText>
                  <ODSText type='sm' color={themeObj.text.primary}>{flowIdInfo?.tenants?.length}</ODSText>
                </View>
                <View style={{ flex: 0.5 }}>
                  <ODSText type='sm-bold' color={themeObj.text.primary}>Rental Amount</ODSText>
                  <ODSText type='sm' color={themeObj.text.primary}>£{flowIdInfo?.open_flow_rental_offer?.rental_amount}</ODSText>
                </View>
              </View>
            </View>
          )}
        </View>
        {type !== "Move Out" && (
          <View style={{ flexDirection: 'column' }}>
            <View style={layoutType !== "web" ? { marginTop: 16 } : { width: 407, marginLeft: 10 }}>
              <RentSetting
                onClick={() => {
                  if (Platform.OS === 'web' && typeof window !== 'undefined') {
                    let redirect_url =
                      `${getServerURL()}/${layoutType === "web" ? "my-account/rent-ready-settings" : "myaccount/rent-ready-settings"}`;
                    window.open(redirect_url, '_self');
                  } else {
                    navigateAction(navigation, "My Account", { to: "rent-ready-settings" });
                  }
                }}
              />
            </View>
            <View style={layoutType !== "web" ? { marginTop: 16 } : { width: 407, marginLeft: 10, marginTop: 16 }}>
              <Report onClick={() => {
                navigateAction(navigation, "ViewMaintenance", { id: flowId, })
              }} />
            </View>
            {shouldShowRentReviewEntryPoints(flowIdInfo) && (
              <View style={layoutType !== "web" ? { marginTop: 16 } : { width: 407, marginLeft: 10, marginTop: 16 }}>
                <RentReviewCard
                  rentReviewData={globalState?.rentReviewData}
                  onReviewRequest={() => {
                    navigateAction(navigation, "RentReview", { id: flowId });
                  }}
                />
              </View>
            )}
          </View>
        )}
      </View>
      <View style={{ alignSelf: "center", flexDirection: "row", top: layoutType != 'web' && -120 }}>
        <ODSText textAlign={'center'} marginTop={30} marginBottom={30} color="black" type={'h5'}>
          {type == "Move Out" ? "Move out" : type == "Renewal" ? "Renewal Progress" : "Move in Progress"}
        </ODSText>
      </View>
      <View style={
        layoutType == 'web'
          ? { alignSelf: 'center', flexDirection: 'row', flexWrap: 'wrap', width: 1050 }
          : { alignSelf: 'center', flexDirection: 'row', flexWrap: 'wrap', width: '100%', top: -120 }
      } >
        {listItemState.map((item, index) => (
          <View style={
            layoutType !== 'web'
              ? { width: '100%', marginBottom: 20 }
              : {
                width: 500,
                margin: 10,
              }
          }>
            <OpenflowCard
              id={item.id}
              IocnColor={
                type == "Move Out" ? themeObj.main.purple[400] : type == "Renewal" ? themeObj.main.pink[400] : themeObj.main.blue[400]
              }
              key={'lti' + index}
              onPress={() => {
                const isMoveOut = type === "Move Out";
                const isCustomRoute = item.routeKey === 'ViewMaintenance' || item.routeKey === 'RentReview';
                const isAllowed = isMoveOut || isCustomRoute || (flowIdInfo && flowIdInfo[item?.buttonStatus] !== 0);
                if (isAllowed) {
                  const nextParams = {
                    id: flowId,
                  };
                  if (isMoveOut) {
                    nextParams.isMoveOut = true;
                  }
                  navigateAction(navigation, item.routeKey, nextParams);
                }
              }}
              type={
                item.routeKey === 'ViewMaintenance'
                  ? 4
                  : item.routeKey === 'RentReview'
                  ? getRentReviewOverallStatus(globalState?.rentReviewData).statusCode
                  : (type === "Move Out"
                      ? getMoveOutItemStatus(item.routeKey)
                      : (flowIdInfo && flowIdInfo[item?.buttonStatus]))
              }
              title={item.title}
              description={item.desc}
              listIcon={item.listIcon}

            />
          </View>
        ))}
      </View>
        </>
      )}
    </BackGroundGenerator>
    // <OpenflowCard/>
    //{renderPropertyBox()}
    //<PropertyBox/>
    // <RentSetting/>
    // <BackGroundGenerator props={props} isTLYF>
    //   <ImageBackground
    //     source={IdRef}
    //     style={{
    //       width: '100%',
    //       height: '170px',
    //       alignItems: 'center',
    //       flexDirection: 'row',
    //       justifyContent: 'space-between',
    //     }}
    //     resizeMode="cover"
    //   >
    //     {authDataFromMobile ? null : (
    //       <BackButton
    //         styles={{ marginTop: 0 }}
    //         navigation={props.navigation}
    //         replace={'Dashboard'}
    //       />
    //     )}
    //   </ImageBackground>

    //   <MainContainer style={{position: "absolute",alignSelf: "center",top:"30%"}}>
    //     {renderPropertyBox()}
    //     <View style={{
    //       width: layoutType == "phone" ? "95%":layoutType == "tab" ? "90%": "1046px",
    //       background: "#ffffff",
    //       boxShadow: "1px 3px 8px rgba(0, 0, 0, 0.15)",
    //       borderRadius: "15px 15px",
    //       height:  layoutType == "phone" ?380 :330,
    //       marginBottom:20,
    //     }}>
    //       <HomeBoxCard
    //         postCodeFromTeancy={globalState?.flowIdInfo?.property?.postcode}
    //         profile={profile?.data}/>
    //     </View>
    //     <Wrapper>
    //       {ListArray.map((item, index) => (
    //         <ListItem
    //           id={item.id}
    //           key={'lti' + index}
    //           onPress={() => {
    //             if (item.buttonStatus === 'property_status') {
    //               navigateAction(navigation, item.routeKey, {
    //                 id: flowId,
    //               });
    //             } else {
    //               flowIdInfo[item?.buttonStatus] === 0
    //                 ? null
    //                 : navigateAction(navigation, item.routeKey, {
    //                     id: flowId,
    //                   });
    //             }
    //           }}
    //           marginBottom={25}
    //           width={layoutType == 'phone' ? '100%' : '49.3%'}
    //           showArrowIcon
    //           showButton
    //           type={flowIdInfo && flowIdInfo[item?.buttonStatus]}
    //           title={item.title}
    //           description={item.desc}
    //           listIcon={item.listIcon}
    //         />
    //       ))}
    //     </Wrapper>

    //   </MainContainer>
    // </BackGroundGenerator>
  );
};
const styles = StyleSheet.create({
  containerStyle: {
    width: '100%',
    borderRadius: 12,
    shadowColor: '#101828',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 2,
    backgroundColor: '#ffffff',
    padding: 20,
    borderWidth: 1,
    borderColor: '#D0D6DD',
    marginTop: 20
  },
  cardStyle: {
    display: 'flex',
    backgroundColor: '#ffffff',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    borderRadius: 10,
    marginHorizontal: 5,
  },
  contentContainer: {
    backgroundColor: '#FFF',
    marginVertical: 10,
  },
  centeredView: {
    flex: 1,
    padding: 20,
    marginTop: 22,
  },
  commonContainerStyles: {
    borderRadius: 16,
    paddingHorizontal: 10,
    paddingVertical: 6,
    flexDirection: 'row',
  },
  floIcon: {
    width: 30,
    height: 30,
    elevation: 5,
    display: 'flex',
    shadowRadius: 3.84,
    shadowOpacity: 0.25,
    shadowColor: '#000',
    tintColor: COLORS.LGREEN,
    shadowOffset: { width: 0, height: 2 },
    marginRight: 8,
  },
  progress: {},
  floBackg: {
    width: 100,
    height: 127,
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
  },
  imageBackgroundContentContainer: {
    marginTop: 10,
    marginBottom: 30,
    width: layoutType == 'phone' ? '90%' : 449,
  },
});
export default Home;
